var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9415 5.48928C14.2159 5.62639 14.5184 5.69776 14.8251 5.69776C15.1318 5.69776 15.4344 5.62639 15.7087 5.48928L19.3253 3.6805C19.4761 3.60515 19.6437 3.56961 19.8121 3.57728C19.9805 3.58495 20.1441 3.63557 20.2875 3.72432C20.4308 3.81307 20.5491 3.93701 20.631 4.08435C20.7129 4.23168 20.7558 4.39753 20.7555 4.56611V17.1821C20.7554 17.3656 20.7042 17.5454 20.6077 17.7015C20.5112 17.8576 20.3731 17.9837 20.2089 18.0657L15.7087 20.3163C15.4344 20.4534 15.1318 20.5248 14.8251 20.5248C14.5184 20.5248 14.2159 20.4534 13.9415 20.3163L9.77834 18.2347C9.50396 18.0976 9.20144 18.0262 8.89471 18.0262C8.58798 18.0262 8.28546 18.0976 8.01108 18.2347L4.39451 20.0435C4.24364 20.1189 4.07598 20.1544 3.90749 20.1467C3.739 20.139 3.57528 20.0883 3.43193 19.9994C3.28857 19.9106 3.17034 19.7865 3.08849 19.639C3.00663 19.4915 2.96388 19.3256 2.9643 19.1569V6.54193C2.9644 6.35842 3.01558 6.17856 3.11212 6.0225C3.20865 5.86643 3.34673 5.74032 3.51088 5.6583L8.01108 3.4077C8.28546 3.2706 8.58798 3.19922 8.89471 3.19922C9.20144 3.19922 9.50396 3.2706 9.77834 3.4077L13.9415 5.48928Z",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8251 5.69727V20.5233",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89465 3.19922V18.0252",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.f01f7eb7a2856b41ad1ccbf9167e5dd9.svg";
export { ForwardRef as ReactComponent };